import { Card, Select, Space } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AcademicYearApiService from '../../../api/AcademicYearApiService';
import SecondaryProgramApiService from '../../../api/SecondaryProgramApiService';
import SecondaryProgramsDataTable from '../../../components/datatables/secondary/SecondaryProgramsDataTable';
import Dropdown from '../../../components/inputs/Dropdown';
import Breadcrumbs from '../../../config/Breadcrumbs';
import Routes from '../../../config/Routes';
import * as GetAcademicYearsHandler from '../../../handlerModels/GetAcademicYearsHandler';
import * as GetSecondaryProgramsHandler from '../../../handlerModels/GetSecondaryProgramsHandler';
import AcademicYearDTO from '../../../models/AcademicYearDTO';
import SecondaryProgramDTO from '../../../models/SecondaryProgramDTO';
import HeaderPortal from '../../../portals/HeaderPortal';
import DateTimeUtil from '../../../utils/DateTimeUtil';
import HistoryUtil from '../../../utils/HistoryUtil';
import ParameterUtil from '../../../utils/ParameterUtil';

interface SecondaryProgramListPageState {
  loading: boolean;
  fromSelfStudies: boolean;
  academicYear: number;
  academicYears: AcademicYearDTO[];
  fromAcademicYearList: boolean;
  secondaryProgram: SecondaryProgramDTO[];
}

interface SecondaryProgramListPageProps {
}

class SecondaryProgramListPage extends React.Component<SecondaryProgramListPageProps & RouteComponentProps<RouteObject>, SecondaryProgramListPageState> {

  constructor(props: SecondaryProgramListPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      loading: false,
      academicYear: 0,
      academicYears: [],
      fromSelfStudies: false,
      fromAcademicYearList: false,
      secondaryProgram: []
    };
  }

  componentDidMount() {
    const id = Number.parseInt(ParameterUtil.getPathPart(this.props.match, 'academicYearId'));
    this.setState({
      fromAcademicYearList: this.props.match.path.split('/').findIndex(x => x == 'academicYearList') > -1,
      fromSelfStudies: this.props.match.path.split('/').findIndex(x => x == 'selfStudy') > -1
    });

    if (this.state.academicYear != id && !isNaN(id)) {
      this.setState({ academicYear: id, fromSelfStudies: true });
      this.loadSecondaryPrograms(id);
      this.loadAcademicYears(id);
    }
    else {
      this.loadAcademicYears(id);
    }
  }

  private loadAcademicYears = (id: number) => {
    this.setState({ loading: true });
    const request = GetAcademicYearsHandler.Request.create({
      academicYearId: isNaN(id) ? null : id
    });
    return AcademicYearApiService.getAcademicYears(request)
      .then((results: GetAcademicYearsHandler.Result) => {
        if (results && results.academicYears) {
          this.setState({
            academicYears: results.academicYears ?? [],
            academicYear: DateTimeUtil.getCurrentYear()
          });
        }
      })
      .catch()
      .finally(() => {
        this.setState({ loading: false })
      });
  }

  private loadSecondaryPrograms = (id: number) => {
    const request = GetSecondaryProgramsHandler.Request.create({
      academicYearId: isNaN(id) ? DateTimeUtil.getCurrentYear() : id
    });

    SecondaryProgramApiService.getSecondaryPrograms(request)
      .then((results: GetSecondaryProgramsHandler.Result) => {
        if (results) {
          this.setState({
            secondaryProgram: results.secondaryPrograms ?? []
          });
        }

      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  private onSelect = (value: any) => {
    this.setState({ academicYear: value });
    this.loadSecondaryPrograms(value);
  }


  private onBack = () => {
    if (this.state.fromAcademicYearList) {
      HistoryUtil.push(Routes.generate(Routes.ACADEMIC_YEAR_DASHBOARD_FROM_LIST, { academicYearId: this.state.academicYear }, {}));
    }
    else if (this.state.fromSelfStudies) {
      HistoryUtil.push(Routes.generate(Routes.SELF_STUDIES_ACADEMIC_YEAR_DASHBOARD, { academicYearId: this.state.academicYear }, {}));
    }
    else {
      HistoryUtil.push(Routes.generate(Routes.SECONDARY_HOME, {}, {}));
    }
  }

  render() {

    return (
      <Content >
        <HeaderPortal title='Secondary CTE Programs'
          breadcrumbs={Breadcrumbs.secondaryProgramList()}
          onBack={this.onBack}
          extra={<>
            <label title={'academicYear'} htmlFor={'academicYear'} />
            <Dropdown
              id='academicYear'
              value={this.state.academicYear}
              onSelect={this.onSelect} dropdownMatchSelectWidth={false}>{this.state.academicYears.map(x => { return this.renderAcademicYear(x); })}</Dropdown>
          </>} />
        < Space direction="vertical" size="large">
          <Card title="Secondary CTE Programs">
            <Space direction='vertical' size="large">
              <SecondaryProgramsDataTable
                academicYear={this.state.academicYear}
                fromAcademicYearDataReview={this.state.fromAcademicYearList} />
            </Space>
          </Card>
        </Space>
      </Content>
    );
  }

  renderAcademicYear(academicYear: AcademicYearDTO) {
    return <Select.Option key={academicYear.id} value={academicYear.id}>{academicYear.id}</Select.Option>
  }
}

export default withRouter(SecondaryProgramListPage);
